module.exports = __webpack_public_path__ + "static/talk-4-ae0e9a29cf5f12b3180f6ec8263bfee9.png";